"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxGroup = exports.Frame = exports.Strong = exports.Strike = exports.Em = exports.UserGroup = exports.UserPicker = exports.Link = exports.Image = exports.User = exports.AdfRenderer = exports.Comment = exports.Popup = exports.InlineEdit = exports.DynamicTable = void 0;
const tslib_1 = require("tslib");
var dynamic_table_1 = require("./dynamic-table");
Object.defineProperty(exports, "DynamicTable", { enumerable: true, get: function () { return dynamic_table_1.DynamicTable; } });
var inline_edit_1 = require("./inline-edit");
Object.defineProperty(exports, "InlineEdit", { enumerable: true, get: function () { return inline_edit_1.InlineEdit; } });
var popup_1 = require("./popup");
Object.defineProperty(exports, "Popup", { enumerable: true, get: function () { return popup_1.Popup; } });
var comment_1 = require("./comment");
Object.defineProperty(exports, "Comment", { enumerable: true, get: function () { return comment_1.Comment; } });
var adf_renderer_1 = require("./adf-renderer");
Object.defineProperty(exports, "AdfRenderer", { enumerable: true, get: function () { return adf_renderer_1.AdfRenderer; } });
/**
 * A component that represents a user, displaying details such as name and profile picture.
 *
 * @see [User](https://developer.atlassian.com/platform/forge/ui-kit/components/user/) in UI Kit documentation for more information
 */
exports.User = 'User';
exports.Image = 'Image';
exports.Link = 'Link';
exports.UserPicker = 'UserPicker';
exports.UserGroup = 'UserGroup';
exports.Em = 'Em';
exports.Strike = 'Strike';
exports.Strong = 'Strong';
/**
 * `Frame` component is in EAP (Early Access Program).
 *
 * For more information, see the {@link https://developer.atlassian.com/platform/forge/ui-kit/components/frame|Frame component} documentation.
 */
exports.Frame = 'Frame';
/**
 * Export Code generated UI Kit 2 Components
 */
tslib_1.__exportStar(require("./ui-kit-components"), exports);
exports.CheckboxGroup = 'CheckboxGroup';
